import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API}/products`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[hsl(var(--cream))] grain-texture flex items-center justify-center">
        <Loader2 className="w-12 h-12 text-[hsl(var(--earth-green))] animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[hsl(var(--cream))] grain-texture">
      <Navbar />

      <section className="pt-32 pb-16">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h1 className="font-heading text-5xl lg:text-6xl text-[hsl(var(--charcoal))] mb-4">
              Shop <span className="text-[hsl(var(--earth-green))] italic">Green</span> Bags
            </h1>
            <p className="font-body text-lg text-[hsl(var(--stone-gray))] max-w-2xl mx-auto">
              Discover our complete collection of biodegradable bags for every need
            </p>
          </div>

          {products.length === 0 ? (
            <div data-testid="no-products" className="text-center py-16">
              <p className="font-body text-lg text-[hsl(var(--stone-gray))]">
                No products available. Check back soon!
              </p>
            </div>
          ) : (
            <div data-testid="products-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductsPage;